export default "__VITE_ASSET__$CkS$Bfx__"